export default __webpack_public_path__ + "static/media/1.aea21380.png";